import { v4 as uuid } from "uuid";

type Subscriber = {
  id: string;
  callback: (event: KeyboardEvent) => void;
};

class KeydownEventStack {
  __subscribers: Record<string, Subscriber[]> = {};

  constructor() {
    window.addEventListener("keydown", this.__next, true);
  }

  __next = (e: KeyboardEvent): void => {
    if (this.__subscribers[e.key] && this.__subscribers[e.key].length) {
      const { callback } =
        this.__subscribers[e.key][this.__subscribers[e.key].length - 1];
      callback(e);
    }
  };

  add = ({
    keys,
    callback,
  }: {
    keys: string[];
    callback: (event: KeyboardEvent) => void;
  }) => {
    const id = uuid();
    keys.forEach((key) => {
      this.__subscribers[key] = this.__subscribers[key] || [];
      this.__subscribers[key].push({ id, callback });
    });
    return {
      remove: () => {
        keys.forEach((key) => {
          this.__subscribers[key] = this.__subscribers[key].filter(
            (s) => s.id !== id,
          );
        });
      },
    };
  };
}

export const keydownEventStack = new KeydownEventStack();
